export const passwordRegex = /(?=.{8,})/;
// export const passwordReg = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/
export const emailRegex =
  /^(([^-`\\\]!@#$%^&*()+=_,?><';:"{}/[|.\s]+(\.[^-`\\\]!@#$%^&*()+=_,?><';:"{}/[|.\s]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const mobileRegex = /^[6-9]\d{9}$/;

export const dateTime = (timestamp) =>
  new Date(timestamp).toISOString().split("T")[0];

export const getLocalTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

// Game list websocket sends "YYYY-MM-DD HH:mm:ss" as IST without a timezone suffix.
export const parseMatchDateTime = (dateTime) => {
  if (!dateTime) return null;
  if (dateTime instanceof Date) return dateTime;

  const value = String(dateTime).trim();
  if (/[zZ]$/.test(value) || /[+-]\d{2}:?\d{2}$/.test(value)) {
    return new Date(value);
  }

  return new Date(`${value.replace(" ", "T")}+05:30`);
};

const getDateKeyInTimezone = (date, timeZone) =>
  new Intl.DateTimeFormat("en-CA", { timeZone }).format(
    parseMatchDateTime(date),
  );

export const formatedTime = (timestamp, timeZone = getLocalTimezone()) => {
  const date = parseMatchDateTime(timestamp);
  if (!date || Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date);
};

export const formatDate = (date) => {
  const day = new Date(date).getDate().toString().padStart(2, "0");
  const month = (new Date(date).getMonth() + 1).toString().padStart(2, "0");
  const year = new Date(date).getFullYear().toString();

  return `${day}-${month}-${year}`;
};

export const isToday = (dateTime, timeZone = getLocalTimezone()) =>
  getDateKeyInTimezone(dateTime, timeZone) ===
  getDateKeyInTimezone(new Date(), timeZone);

export const SUB_ADMIN_ID = "652500739621e8db6288f8b8";

export function getFormattedDateTime() {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const now = new Date();

  const dayName = days[now.getDay()];
  const day = now.getDate();
  const month = months[now.getMonth()];
  const year = now.getFullYear();

  const hours = now.getHours().toString().padStart(2, "0");
  const minutes = now.getMinutes().toString().padStart(2, "0");
  const seconds = now.getSeconds().toString().padStart(2, "0");

  const isIST = true; // You can add logic to dynamically determine timezone if needed
  const timezone = isIST ? "IST" : "UTC";

  const formattedDate = `${dayName} ${month} ${day}, ${year}`;
  const formattedTime = `${hours}:${minutes}:${seconds}  ${timezone}`;

  return { formattedDate, formattedTime };
}

export function getDateOrDay(date, timeZone = getLocalTimezone()) {
  const inputDate = parseMatchDateTime(date);
  const currentDate = new Date();
  const inputKey = getDateKeyInTimezone(inputDate, timeZone);
  const todayKey = getDateKeyInTimezone(currentDate, timeZone);

  if (inputKey === todayKey) {
    return "Today";
  }

  const tomorrow = new Date(currentDate);
  tomorrow.setDate(currentDate.getDate() + 1);
  if (inputKey === getDateKeyInTimezone(tomorrow, timeZone)) {
    return "Tomorrow";
  }

  const fiveDaysLater = new Date(currentDate);
  fiveDaysLater.setDate(currentDate.getDate() + 5);
  const fiveDaysLaterKey = getDateKeyInTimezone(fiveDaysLater, timeZone);

  if (inputKey >= todayKey && inputKey <= fiveDaysLaterKey) {
    return new Intl.DateTimeFormat("en-US", {
      timeZone,
      weekday: "long",
    }).format(inputDate);
  }

  return inputDate.toLocaleDateString("en-GB", { timeZone });
}
